/* eslint-disable import/prefer-default-export */
import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import {
  shouldShowProceeds,
  shouldShowLastLoanSpreadEdit,
  shouldShowFallbackRateEdit,
  shouldShowFixedIndexes,
  shouldShowFloatingIndexes,
  shouldShowRateEdit,
  shouldShowMezzFundingStructureId,
  shouldShowMezzRateTypeId,
  shouldShowLastModifiedDate,
  isLoanFloatingRateType,
  shouldShowRateReductionTerms
} from "./section-general-information-row-logic";

export const rows = (flags) => {
  
  const hideLoanEconomicsFields = flags.bad139HideLoanEconomicsFields;
  
  return {
    title: {
      isTitle: true,
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.TEXT,
          value: "General Information",
          style: {
            marginLeft: "0",
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "16px",
            lineHeight: "14px",
            textTransform: "uppercase",
            color: "#000000",
            marginBottom: "10px"
          }
        },
        {
          type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
          referencedFieldPath: "loans.generalinformation.header"
        }
      ]
    },
    loanAmount: {
      label: "Loan Amount",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
          name: "details.amount",
          variant: "filled"
        }
      ]
    },
    initialProceeds: {
      isVisible: data => shouldShowProceeds(data),
      label: "Initial Proceeds",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
          name: "details.initialProceeds",
          variant: "filled"
        }
      ]
    },
    proceedsDrawn: {
      isVisible: data => shouldShowProceeds(data),
      label: "Proceeds Drawn",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
          name: "details.proceedsDrawn",
          variant: "filled"
        }
      ]
    },
    proceedsDrawnAsOf: {
      isVisible: data => shouldShowProceeds(data),
      label: "Proceeds Drawn As Of",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.DATE,
          name: "details.proceedsDrawnAsOf",
          variant: "filled"
        }
      ]
    },
    closingDate: {
      label: "Closing Date",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.DATE,
          name: "details.closingDate",
          variant: "filled"
        },
        {
          type: FORM_BUILDER_FIELD_TYPE.SWITCH,
          name: "details.isClosingDateAssumed",
          variant: "filled",
          label: "Assumed",
          altlabel: "Not Assumed",
          hideLabel: true,
          className: "closingDateAssumed"
        }
      ]
    },
    modifiedDate: {
      isVisible: data => shouldShowLastModifiedDate(data),
      label: "Modified Date",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.DATE,
          name: "details.lastModifiedDate",
          variant: "filled"
        }
      ]
    },
    maturityDate: {
      label: "Maturity Date",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.DATE,
          name: "details.maturityDate",
          variant: "filled"
        }
      ]
    },
    extendedMaturityDate: {
      label: "Extended Maturity Date",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.DATE,
          name: "details.extendedMaturityDate",
          variant: "filled"
        }
      ]
    },
    rateType: {
      label: "Rate Type",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
          name: "details.rateTypeId",
          variant: "filled",
          displayWith: option => option.name,
          setValueWith: option => option.id,
          options: [
            { name: "Fixed", id: "53669856-4681-11e9-82f6-0242ac120002" },
            { name: "Floating", id: "5813c493-4681-11e9-82f6-0242ac120002" }
          ]
        }
      ]
    },
    fixedIndexes: {
      isVisible: data => shouldShowFixedIndexes(data),
      label: "Index",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
          name: "details.indexId",
          variant: "filled",
          displayWith: option => option.name,
          setValueWith: option => option.id,
          parentId: "fixedIndexes"
        }
      ]
    },
    floatingIndexes: {
      isVisible: data => shouldShowFloatingIndexes(data),
      label: "Index",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
          name: "details.indexId",
          variant: "filled",
          displayWith: option => option.name,
          setValueWith: option => option.id,
          parentId: "floatingIndexes"
        }
      ]
    },
    loanSpread: {
      isVisible: data => shouldShowLastLoanSpreadEdit(data),
      label: "Loan Spread",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.PERCENT,
          name: "details.loanSpread",
          variant: "filled",
          decimals: 3
        }
      ]
    },
    fallbackRate: {
      isVisible: data => shouldShowFallbackRateEdit(data),
      label: "Fallback Rate",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.STRING,
          name: "details.fallbackRate",
          variant: "filled"
        }
      ]
    },
    interestRate: {
      isVisible: data => shouldShowRateEdit(data),
      label: "Rate",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.PERCENT,
          name: "details.interestRate",
          variant: "filled",
          decimals: 3
        }
      ]
    },
    daycount: {
      label: "Daycount",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
          name: "details.daycountId",
          variant: "filled",
          parentId: "daycountList",
          displayWith: option => option.name,
          setValueWith: option => option.value
        }
      ]
    },
    lookback: {
      isVisible: data => isLoanFloatingRateType(data),
      label: "Lookback",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.NUMBER,
          name: "details.lookbackDays",
          variant: "filled"
        }
      ]
    },
    rounding: {
      isVisible: data => isLoanFloatingRateType(data),
      label: "Rounding",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
          name: "details.roundingId",
          variant: "filled",
          parentId: "roundingList",
          displayWith: option => option.name,
          setValueWith: option => option.value
        }
      ]
    },
    embeddedFloor: {
      isVisible: data => isLoanFloatingRateType(data),
      label: "Embedded Floor",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.PERCENT,
          name: "details.indexFloor",
          variant: "filled",
          decimals: 3
        }
      ]
    },
    embeddedCap: {
      isVisible: data => isLoanFloatingRateType(data),
      label: "Embedded Cap",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.PERCENT,
          name: "details.embeddedCap",
          variant: "filled",
          decimals: 3
        }
      ]
    },
    rateModification: {
      isVisible: loan => isLoanFloatingRateType(loan),
      label: "Rate Modification",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.STRING,
          name: "details.spreadReductionTerms",
          variant: "filled",
          multiline: true
        }
      ]
    },
    conversionOption: {
      label: "Conversion Option",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.STRING,
          name: "details.conversionOption",
          variant: "filled",
          multiline: true
        }
      ]
    },
    mezzFundingStructureId: {
      isVisible: data => shouldShowMezzFundingStructureId(data),
      label: "Funding Structure",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
          name: "details.mezzFundingStructureId",
          variant: "filled",
          displayWith: option => option.name,
          setValueWith: option => option.id,
          options: [
            { name: "Sequential", id: "0f6ecdb7-4696-11e9-82f6-0242ac120002" },
            { name: "Upfront", id: "1637af02-4696-11e9-82f6-0242ac120002" }
          ]
        }
      ]
    },
    mezzRateTypeId: {
      isVisible: data => shouldShowMezzRateTypeId(data),
      label: "Mezz Rate",
      cells: [
        {
          type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
          name: "details.mezzRateTypeId",
          variant: "filled",
          displayWith: option => option.name,
          setValueWith: option => option.id,
          options: [
            { name: "Accrued", id: "da3a1209-4695-11e9-82f6-0242ac120002" },
            { name: "Current", id: "dd85fe16-4695-11e9-82f6-0242ac120002" }
          ]
        }
      ]
    }
  }
};
